import { render, staticRenderFns } from "./AbteilungenIcon.vue?vue&type=template&id=6e97835e"
import script from "./AbteilungenIcon.vue?vue&type=script&lang=js"
export * from "./AbteilungenIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports